import { render, staticRenderFns } from "./Look.vue?vue&type=template&id=c0b032f4&scoped=true&"
import script from "./Look.vue?vue&type=script&lang=js&"
export * from "./Look.vue?vue&type=script&lang=js&"
import style0 from "./Look.vue?vue&type=style&index=0&id=c0b032f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b032f4",
  null
  
)

export default component.exports